module.exports = __webpack_public_path__ + "img/中国农业大学.44a84919.png";